<template>
  <layout :session="session">
    <div class="mt-6 py-5 text-left max-w-sm mx-auto px-4">
      <p class="text-sm mb-2">Frage {{ currentQuestionId }} von 5</p>
      <h1 class="text-lg font-extralight">
        {{ currentQuestion.question }}
      </h1>
      <h2 v-if="currentQuestion.sub_question" class="mt-3 text-sm font-extralight">
        {{ currentQuestion.sub_question }}
      </h2>

      <div class="border-t border-gray-400 mt-4 mb-6"></div>

      <rating :session="session" :translations="translations"></rating>
    </div>

    <template v-slot:footer>
      <a
        v-if="nextQuestionId >= 1 && nextQuestionId <= 5"
        :href="
          route('control-panel.phase', {
            sessionUuid: session.uuid,
            phaseId: currentPhaseId,
            step: nextStep,
          })
        "
        class="inline-flex justify-center w-full sm:w-min rounded-none sm:rounded-md border border-transparent px-3 py-1.5 sm:my-2 sm:px-2 sm:py-2 bg-brandpreneurship-dark-gray text-base leading-6 font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50"
        >WEITER</a
      >

      <a
        v-if="nextStep == 'result1'"
        :href="route('control-panel.phase', { sessionUuid: session.uuid, phaseId: currentPhaseId, step: nextStep })"
        class="inline-flex justify-center w-full sm:w-min rounded-none sm:rounded-md border border-transparent px-3 py-1.5 sm:my-2 sm:px-2 sm:py-2 bg-brandpreneurship-dark-gray text-base leading-6 font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 uppercase z-50"
        >WEITER</a
      >
    </template>
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import Rating from '@/Pages/LiveResults/Rating';

export default {
  metaInfo() {
    return {
      title: `${this.currentQuestion.question}`,
    };
  },

  components: {
    Layout,
    Rating,
  },

  props: ['session', 'phase', 'currentPhaseId', 'nextPhaseId', 'step', 'nextStep', 'translations'],

  computed: {
    currentQuestion() {
      let idx = this.step.replace('question', '');

      return this.phase.data[(idx-1)];
    },

    currentQuestionId() {
      return this.step.replace('question', '');
    },

    nextQuestionId() {
      return this.nextStep.replace('question', '');
    },
  },
};
</script>